import { SharedModule } from '@aiwyn/shared';
import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import {
  EngagementListItem,
  EngagementListPrepaymentStatusColor,
  EngagementListPrepaymentStatusDisplay,
  EngagementListStatusColor,
  EngagementListStatusDisplay,
} from '../../../../api/models';

@Component({
  selector: 'app-engagement-card-item',
  templateUrl: './engagement-card-item.component.html',
  styleUrls: ['./engagement-card-item.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule],
})
export class EngagementCardItemComponent {
  readonly engagement = input.required<EngagementListItem>();

  readonly EngagementListStatusDisplay = EngagementListStatusDisplay;
  readonly EngagementListStatusColor = EngagementListStatusColor;
  readonly EngagementListPrepaymentStatusDisplay = EngagementListPrepaymentStatusDisplay;
  readonly EngagementListPrepaymentStatusColor = EngagementListPrepaymentStatusColor;
}
